import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Typography,
  Row,
  Col,
  Button,
  Card,
  Modal,
  Select,
  Spin,
  Tree,
} from "antd";
import {
  UploadOutlined,
  PlusOutlined,
  HomeOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";

import PieChart from "../graph-plots/pie";
import StatsCard from "../../../../Components/StatsCard";

import BarChart from "../graph-plots/bar";
import TableSearch from "../../../../Components/TableSearch";

import InputLabel from "../../../../Components/FloatingSelectLabel/FloatingSelectLabel";
// redux
import { getDistricts } from "../../../../actionCreators/DropDown";

import { getRegisteredPropertiesPercentagesByZone } from "../../../../actionCreators/Property";
import {
  getYearlyPaidAndPendingUnits,
  getYearlyTotalAndPaidTax,
} from "../../../../actionCreators/TaxCollection";
import { getEtoZones } from "../../../../actionCreators/Zones";
import {
  formatYearlyTotalAndPaidTax,
  formatUnitsOfProperties,
  customColorFunction,
  formatLabelFunction,
  tooltipFormatterFunction,
} from "../../../../utils/reportsUtils";

import { useHistory, Link } from "react-router-dom";
import { getFiscalYear } from "../../../../utils/dateTime";
const { Option } = Select;
const AdminReports = ({
  user,
  getDistricts,
  districts,
  getRegisteredPropertiesPercentagesByZone,
  registeredPropertiesPercentagesByZone,
  getYearlyPaidAndPendingUnits,
  getYearlyTotalAndPaidTax,
  yearlyTotalAndPaidTax,
  yearlyPaidAndPendingUnits,
  getEtoZones,
  etoZones,
}) => {
  const styles = {
    titleButtonParent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      padding: "7px 18px",
      background: "#284F68",
      color: "white",
      borderRadius: "5px",
      fontWeight: "500",
      fontSize: "15px",
      cursor: "pointer",
      marginRight: "8px",
    },
    contentWrapper: {
      marginLeft: "10px",
      marginRight: "10px",
    },
  };

  const history = useHistory();

  const [selectedDistrict, setSelectedDistrict] = React.useState(null);
  const [statusSelectActive, setStatusSelectActive] = React.useState(false);
  const [total, setTotal] = React.useState(0);
  const [pieChartData, setPieChartData] = React.useState([]);
  const [
    yearlyPaidAndPendingUnitsModalVisible,
    setYearlyPaidAndPendingUnitsModalVisible,
  ] = React.useState(false);
  const [
    yearlyPaidAndPendingTaxModalVisible,
    setYearlyPaidAndPendingTaxModalVisible,
  ] = React.useState(false);
  const [numberOfYearsSelectedUnitsModal, setNumberOfYearsSelectedUnitsModal] =
    React.useState(10);
  const [numberOfYearsSelected, setNumberOfYearsSelected] = React.useState(10);
  const [yearlyPaidAndPendingUnitsState, setYearlyPaidAndPendingUnitsState] =
    React.useState([]);
  const [
    yearlyPaidAndPendingUnitsExpended,
    setYearlyPaidAndPendingUnitsExpended,
  ] = React.useState([]);
  const [
    yearlyPaidAndPendingTaxExpendedData,
    setYearlyPaidAndPendingTaxExpendedData,
  ] = React.useState([]);
  const [yearlyPaidAndPendingTaxData, setYearlyPaidAndPendingTaxData] =
    React.useState([]);
  const [demandCurrentFiscalYear, setDemandCurrentFiscalYear] =
    React.useState("");
  const [zonesAndCircles, setZonesAndCircles] = React.useState(null);
  const [expandedKeys, setExpandedKeys] = React.useState([]);

  const getDistrictOptions = (districtList) =>
    districtList?.map((x) => <Option value={x?.id}>{x?.name}</Option>);
  const getDistrictName = (districtId) => {
    if (districtId && districts?.data) {
      return districts?.data?.find((x) => x?.id === districtId)?.name;
    } else {
      return "-";
    }
  };

  const onUnitsExpandButtonClick = (event) => {
    event.preventDefault();
    setYearlyPaidAndPendingUnitsModalVisible(true);
  };
  const onExpandButtonClick = (event) => {
    event.preventDefault();
    setYearlyPaidAndPendingTaxModalVisible(true);
  };

  React.useEffect(() => {
    getDistricts();
  }, []);
  React.useEffect(() => {
    if (districts?.data) {
      const districtId = localStorage?.getItem("rd");
      if (districtId) {
        const selectedDistrict = JSON?.parse(districtId);
        if (selectedDistrict) {
          setSelectedDistrict(selectedDistrict);
        }
      }
    }
  }, [districts]);
  // React.useEffect(() => {
  //     if (districts?.data) {
  //         setSelectedDistrict(districts?.data[0]?.id)
  //     }
  // }, [districts])
  const handleChange=(data)=>{
    setSelectedDistrict(data)
  }
  React.useEffect(() => {
    //setup for totalRegisteredProperties
    if (registeredPropertiesPercentagesByZone?.data) {
      // if (total === 0) {
      let sumTotal = 0;
      registeredPropertiesPercentagesByZone?.data?.map((count) => {
        sumTotal = sumTotal + count.propertyCount;
      });
      setTotal(sumTotal);
      // }

      if (registeredPropertiesPercentagesByZone?.data) {
        setPieChartData(registeredPropertiesPercentagesByZone?.data);
      }
    }
  }, [registeredPropertiesPercentagesByZone?.data]);

  React.useEffect(() => {
    const [unitsData, initialThreeYearsData] = formatUnitsOfProperties(
      yearlyPaidAndPendingUnits.data,
      numberOfYearsSelectedUnitsModal
    );
    setYearlyPaidAndPendingUnitsState(initialThreeYearsData);
    setYearlyPaidAndPendingUnitsExpended(unitsData);
  }, [yearlyPaidAndPendingUnits]);

  React.useEffect(() => {
    const [unitsData] = formatUnitsOfProperties(
      yearlyPaidAndPendingUnits.data,
      numberOfYearsSelectedUnitsModal
    );
    setYearlyPaidAndPendingUnitsExpended(unitsData);
  }, [numberOfYearsSelectedUnitsModal]);

  React.useEffect(() => {
    const [newTaxDetails, initialData] = formatYearlyTotalAndPaidTax(
      yearlyTotalAndPaidTax?.data,
      numberOfYearsSelected
    );
    setYearlyPaidAndPendingTaxExpendedData(newTaxDetails);
    setYearlyPaidAndPendingTaxData(initialData);
    const currentYear = getFiscalYear();
    const totalTaxCurrentYear = yearlyTotalAndPaidTax?.data?.filter(
      (item) => +item?.taxyear === currentYear
    )[0]?.total_tax;
    setDemandCurrentFiscalYear(totalTaxCurrentYear);
  }, [yearlyTotalAndPaidTax]);

  React.useEffect(() => {
    const [newTaxDetails] = formatYearlyTotalAndPaidTax(
      yearlyTotalAndPaidTax.data,
      numberOfYearsSelected
    );
    setYearlyPaidAndPendingTaxExpendedData(newTaxDetails);
  }, [numberOfYearsSelected]);

  React.useEffect(() => {
    setZonesAndCircles(
      etoZones.data.map((zone) => {
        return {
          title: (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Typography className="treeTitle">{zone.name}</Typography>
              <Link to={`/reports/zone/${zone.id}`} className="ViewButton">
                View
              </Link>
            </div>
          ),
          key: zone.id,
          children: zone.circles.map((circle) => ({
            title: (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Typography className="childTitle">{circle?.name}</Typography>
                <Link
                  to={`/reports/circle/${circle?.id}`}
                  className="ViewButton"
                >
                  View
                </Link>
              </div>
            ),
            key: circle.id,
          })),
        };
      })
    );
    setExpandedKeys(
      etoZones.data.map((zone) => {
        return zone.id;
      })
    );
  }, [etoZones]);

  React.useEffect(() => {
    //trigger functions after district id change.
    if (selectedDistrict) {
      const obj = { districtId: selectedDistrict };
      getRegisteredPropertiesPercentagesByZone(obj);
      getYearlyPaidAndPendingUnits(obj);
      getYearlyTotalAndPaidTax(obj);
      getEtoZones(obj);
    }
  }, [selectedDistrict]);

  React.useEffect(() => {
    if(selectedDistrict)
    {
      localStorage.setItem("rd",selectedDistrict)
    }
  }, [selectedDistrict]);

  if ([null, undefined].includes(districts?.data))
    return (
      <div className="spin-loader">
        <Spin size="large" />
      </div>
    );
  return (
    <React.Fragment>
      <div style={styles.titleButtonParent}>
        <div>
          <Typography className="heading">
            Reports Overview ({getDistrictName(selectedDistrict)})
          </Typography>
        </div>
        <Button
          // style={styles.uploadButton}
          className="export-report-button"
          type={selectedDistrict ? "primary" : "ghost"}
          // icon={<UploadOutlined />}
          size={"large"}
          icon={<FilePdfOutlined />}
          disabled={selectedDistrict?false:true}
          onClick={() =>
            history.push(`/reports/overview-pdf/${selectedDistrict}`)
          }
        >
          Export Report
        </Button>
      </div>

      <Card bordered={false} style={{ marginBottom: "10px" }}>
        <Typography.Text style={{ fontSize: "20px" }}>
          Select District
        </Typography.Text>
        <div style={styles.contentWrapper}>
          <div
            onFocus={() => {
              setStatusSelectActive(true);
            }}
            onBlur={() => {
              setStatusSelectActive(false);
            }}
            style={{ marginTop: "25px", height: "40px" }}
          >
            <InputLabel
              value={selectedDistrict}
              labelText="District"
              active={statusSelectActive}
            >
              <Select
                disabled={false}
                value={selectedDistrict}
                onChange={handleChange}
                size="large"
              >
                {getDistrictOptions(districts?.data)}
              </Select>
            </InputLabel>
          </div>
        </div>
      </Card>

      {selectedDistrict && (
        <>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Card
                className="report-stats-header"
                bordered={false}
                style={{ marginBottom: "24px" }}
              >
                <Typography className="report-stats-header">
                  TOTAL REGISTERED PROPERTIES
                </Typography>
                {!registeredPropertiesPercentagesByZone?.loading && (
                  <Typography className="report-stats-data">{total}</Typography>
                )}

                <PieChart
                  loading={registeredPropertiesPercentagesByZone?.loading}
                  data={pieChartData}
                  angleField="propertyCount"
                  colorField="zone"
                  isNoData={!pieChartData?.length}
                />
              </Card>
              <br />
              <div className="report-stats-container">
                <Typography className="report-stats-header">
                  TOTAL DEMAND CURRENT FISCAL YEAR
                </Typography>
                {!yearlyTotalAndPaidTax?.loading ? (
                  <div className="report-stats-data">
                    PKR{" "}
                    {demandCurrentFiscalYear
                      ? parseInt(demandCurrentFiscalYear)?.toLocaleString()
                      : 0}
                  </div>
                ) : (
                  <div className="report-stats-data center-loader">
                    <Spin />
                  </div>
                )}
              </div>
            </Col>

            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Card bordered={false} className="full-height-card">
                <Row>
                  <Col xl={12}>
                    <Typography className="report-stats-header">
                      Yearly Tax Overview
                    </Typography>
                  </Col>
                  <Col xl={12}>
                    <div>
                      <Button
                        className="overlay-btn"
                        onClick={onExpandButtonClick}
                        disabled={!yearlyTotalAndPaidTax?.data?.length}
                      >
                        Expand
                      </Button>
                    </div>
                  </Col>
                </Row>
                <BarChart
                  data={yearlyPaidAndPendingTaxData}
                  loading={yearlyTotalAndPaidTax?.loading}
                  // height={369}
                  xField="year"
                  yField="tax"
                  customColorFtn={customColorFunction}
                  colorFieldName={"name"}
                  formatLabelFunction={formatLabelFunction}
                  tooltipFormatterFunction={tooltipFormatterFunction}
                  isNoData={!yearlyTotalAndPaidTax?.data?.length}
                  xLabel="Fiscal Year"
                  yLabel="Tax (PKR)"
                />
              </Card>
            </Col>

            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Card bordered={false} className="full-height-card">
                <Row>
                  <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Typography className="report-stats-header">
                      Tax Units Overview
                    </Typography>
                  </Col>
                  <Col xs={24} sm={24} lg={12} xl={12}>
                    <Button
                      className="overlay-btn"
                      onClick={onUnitsExpandButtonClick}
                      disabled={!yearlyPaidAndPendingUnits?.data?.length}
                    >
                      Expand
                    </Button>
                  </Col>
                </Row>
                <BarChart
                  data={yearlyPaidAndPendingUnitsState}
                  loading={yearlyPaidAndPendingUnits?.loading}
                  xField="year"
                  yField="units"
                  customColorFtn={customColorFunction}
                  colorFieldName={"name"}
                  formatLabelFunction={formatLabelFunction}
                  isNoData={!yearlyPaidAndPendingUnits?.data?.length}
                  xLabel="Fiscal Year"
                  yLabel="Units (Properties)"
                />
              </Card>
            </Col>
          </Row>
          <div>
            <Typography className="heading">
              Reports of Zones and Circles
            </Typography>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                {etoZones.loading ? (
                  <div className="spin-loader" style={{ height: "10vh" }}>
                    <Spin size="large" />
                  </div>
                ) : (
                  <Tree
                    blockNode={true}
                    expandedKeys={expandedKeys}
                    rootStyle={{
                      width: "100%",
                      padding: "10px",
                    }}
                    treeData={zonesAndCircles}
                  />
                )}
              </Col>
            </Row>
          </div>
        </>
      )}
      <Modal
        title="Tax Units Overview"
        visible={yearlyPaidAndPendingUnitsModalVisible}
        onOk={() => {
          setYearlyPaidAndPendingUnitsModalVisible(false);
        }}
        onCancel={() => {
          setYearlyPaidAndPendingUnitsModalVisible(false);
        }}
        width="60%"
        className="expanded-modal"
      >
        <div>
          <Row gutter={16}>
            <Col span={24}>
              <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <Select
                  defaultValue={numberOfYearsSelectedUnitsModal}
                  onChange={(value) => {
                    setNumberOfYearsSelectedUnitsModal(value);
                  }}
                >
                  <Select.Option value={10}>Last 10 years</Select.Option>
                  <Select.Option value={20}>Last 20 years</Select.Option>
                  <Select.Option value={30}>Last 30 years</Select.Option>
                </Select>
              </div>
              <BarChart
                data={yearlyPaidAndPendingUnitsExpended}
                xField="year"
                yField="units"
                customColorFtn={customColorFunction}
                colorFieldName={"name"}
                formatLabelFunction={formatLabelFunction}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal
        title="Yearly Tax Overview"
        visible={yearlyPaidAndPendingTaxModalVisible}
        onOk={() => {
          setYearlyPaidAndPendingTaxModalVisible(false);
        }}
        onCancel={() => {
          setYearlyPaidAndPendingTaxModalVisible(false);
        }}
        className="expanded-modal"
        width="60%"
      >
        <div>
          <Row gutter={16}>
            <Col span={24}>
              <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <Select
                  defaultValue={numberOfYearsSelected}
                  onChange={(value) => {
                    setNumberOfYearsSelected(value);
                  }}
                >
                  <Select.Option value={10}>Last 10 years</Select.Option>
                  <Select.Option value={20}>Last 20 years</Select.Option>
                  <Select.Option value={30}>Last 30 years</Select.Option>
                </Select>
              </div>
              <BarChart
                data={yearlyPaidAndPendingTaxExpendedData}
                xField="year"
                yField="tax"
                customColorFtn={customColorFunction}
                colorFieldName={"name"}
                formatLabelFunction={formatLabelFunction}
                tooltipFormatterFunction={tooltipFormatterFunction}
              />
            </Col>
          </Row>
        </div>
      </Modal>
    </React.Fragment>
  );
};
const mapStateToProps = ({
  user: user,
  dropDown: { districts },
  property: { registeredPropertiesPercentagesByZone },
  taxCollection: { yearlyTotalAndPaidTax, yearlyPaidAndPendingUnits },
  zones: { etoZones },
}) => ({
  districts,
  registeredPropertiesPercentagesByZone,
  yearlyTotalAndPaidTax,
  yearlyPaidAndPendingUnits,
  etoZones,
});

const mapDispatchToProps = (dispatch) => ({
  getDistricts: bindActionCreators(getDistricts, dispatch),
  getRegisteredPropertiesPercentagesByZone: bindActionCreators(
    getRegisteredPropertiesPercentagesByZone,
    dispatch
  ),
  getYearlyPaidAndPendingUnits: bindActionCreators(
    getYearlyPaidAndPendingUnits,
    dispatch
  ),
  getYearlyTotalAndPaidTax: bindActionCreators(
    getYearlyTotalAndPaidTax,
    dispatch
  ),
  getEtoZones: bindActionCreators(getEtoZones, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminReports);
